module.exports = __webpack_public_path__ + "static/media/table.7a308106.png";